import { Action } from 'redux'
import { SIGN_OUT_SUCCESS } from 'actions'

export const createSignOutSuccessAction = (): Action => {
  return {
    type: SIGN_OUT_SUCCESS,
  }
}
